var pr = Object.defineProperty;
var t = (r, e) => pr(r, "name", { value: e, configurable: !0 });
var V = typeof global == "object" && global && global.Object === Object && global, xr = typeof self == "object" && self && self.Object === Object && self, c = V || xr || Function("return this")(), d = c.Symbol, Z = Object.prototype, yr = Z.hasOwnProperty, lr = Z.toString, g = d ? d.toStringTag : void 0;
function jr(r) {
  var e = yr.call(r, g), n = r[g];
  try {
    r[g] = void 0;
    var u = !0;
  } catch {
  }
  var a = lr.call(r);
  return u && (e ? r[g] = n : delete r[g]), a;
}
t(jr, "getRawTag");
var Tr = Object.prototype, mr = Tr.toString;
function vr(r) {
  return mr.call(r);
}
t(vr, "objectToString");
var Ar = "[object Null]", Or = "[object Undefined]", h = d ? d.toStringTag : void 0;
function b(r) {
  return r == null ? r === void 0 ? Or : Ar : h && h in Object(r) ? jr(r) : vr(r);
}
t(b, "baseGetTag");
function y(r) {
  return r != null && typeof r == "object";
}
t(y, "isObjectLike");
var Sr = "[object Symbol]";
function hr(r) {
  return typeof r == "symbol" || y(r) && b(r) == Sr;
}
t(hr, "isSymbol");
function $r(r, e) {
  for (var n = -1, u = r == null ? 0 : r.length, a = Array(u); ++n < u; )
    a[n] = e(r[n], n, r);
  return a;
}
t($r, "arrayMap");
var _ = Array.isArray, $ = d ? d.prototype : void 0, w = $ ? $.toString : void 0;
function G(r) {
  if (typeof r == "string")
    return r;
  if (_(r))
    return $r(r, G) + "";
  if (hr(r))
    return w ? w.call(r) : "";
  var e = r + "";
  return e == "0" && 1 / r == -1 / 0 ? "-0" : e;
}
t(G, "baseToString");
function H(r) {
  var e = typeof r;
  return r != null && (e == "object" || e == "function");
}
t(H, "isObject");
var wr = "[object AsyncFunction]", Cr = "[object Function]", Rr = "[object GeneratorFunction]", Pr = "[object Proxy]";
function J(r) {
  if (!H(r))
    return !1;
  var e = b(r);
  return e == Cr || e == Rr || e == wr || e == Pr;
}
t(J, "isFunction");
var l = c["__core-js_shared__"], C = function() {
  var r = /[^.]+$/.exec(l && l.keys && l.keys.IE_PROTO || "");
  return r ? "Symbol(src)_1." + r : "";
}();
function Er(r) {
  return !!C && C in r;
}
t(Er, "isMasked");
var Mr = Function.prototype, Ir = Mr.toString;
function f(r) {
  if (r != null) {
    try {
      return Ir.call(r);
    } catch {
    }
    try {
      return r + "";
    } catch {
    }
  }
  return "";
}
t(f, "toSource");
var Ur = /[\\^$.*+?()[\]{}|]/g, kr = /^\[object .+?Constructor\]$/, Lr = Function.prototype, Dr = Object.prototype, Nr = Lr.toString, Fr = Dr.hasOwnProperty, zr = RegExp(
  "^" + Nr.call(Fr).replace(Ur, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Wr(r) {
  if (!H(r) || Er(r))
    return !1;
  var e = J(r) ? zr : kr;
  return e.test(f(r));
}
t(Wr, "baseIsNative");
function Br(r, e) {
  return r == null ? void 0 : r[e];
}
t(Br, "getValue");
function x(r, e) {
  var n = Br(r, e);
  return Wr(n) ? n : void 0;
}
t(x, "getNative");
var T = x(c, "WeakMap"), Vr = 9007199254740991;
function K(r) {
  return typeof r == "number" && r > -1 && r % 1 == 0 && r <= Vr;
}
t(K, "isLength");
function Zr(r) {
  return r != null && K(r.length) && !J(r);
}
t(Zr, "isArrayLike");
var _r = Object.prototype;
function q(r) {
  var e = r && r.constructor, n = typeof e == "function" && e.prototype || _r;
  return r === n;
}
t(q, "isPrototype");
var Gr = "[object Arguments]";
function R(r) {
  return y(r) && b(r) == Gr;
}
t(R, "baseIsArguments");
var Y = Object.prototype, Hr = Y.hasOwnProperty, Jr = Y.propertyIsEnumerable, Kr = R(/* @__PURE__ */ function() {
  return arguments;
}()) ? R : function(r) {
  return y(r) && Hr.call(r, "callee") && !Jr.call(r, "callee");
};
function qr() {
  return !1;
}
t(qr, "stubFalse");
var X = typeof exports == "object" && exports && !exports.nodeType && exports, P = X && typeof module == "object" && module && !module.nodeType && module, Yr = P && P.exports === X, E = Yr ? c.Buffer : void 0, Xr = E ? E.isBuffer : void 0, Qr = Xr || qr, re = "[object Arguments]", ee = "[object Array]", te = "[object Boolean]", ne = "[object Date]", oe = "[object Error]", ue = "[object Function]", ae = "[object Map]", ce = "[object Number]", ie = "[object Object]", fe = "[object RegExp]", se = "[object Set]", de = "[object String]", be = "[object WeakMap]", ge = "[object ArrayBuffer]", pe = "[object DataView]", xe = "[object Float32Array]", ye = "[object Float64Array]", le = "[object Int8Array]", je = "[object Int16Array]", Te = "[object Int32Array]", me = "[object Uint8Array]", ve = "[object Uint8ClampedArray]", Ae = "[object Uint16Array]", Oe = "[object Uint32Array]", o = {};
o[xe] = o[ye] = o[le] = o[je] = o[Te] = o[me] = o[ve] = o[Ae] = o[Oe] = !0;
o[re] = o[ee] = o[ge] = o[te] = o[pe] = o[ne] = o[oe] = o[ue] = o[ae] = o[ce] = o[ie] = o[fe] = o[se] = o[de] = o[be] = !1;
function Se(r) {
  return y(r) && K(r.length) && !!o[b(r)];
}
t(Se, "baseIsTypedArray");
function he(r) {
  return function(e) {
    return r(e);
  };
}
t(he, "baseUnary");
var Q = typeof exports == "object" && exports && !exports.nodeType && exports, p = Q && typeof module == "object" && module && !module.nodeType && module, $e = p && p.exports === Q, j = $e && V.process, M = function() {
  try {
    var r = p && p.require && p.require("util").types;
    return r || j && j.binding && j.binding("util");
  } catch {
  }
}(), I = M && M.isTypedArray, we = I ? he(I) : Se;
function Ce(r, e) {
  return function(n) {
    return r(e(n));
  };
}
t(Ce, "overArg");
var Re = Ce(Object.keys, Object), Pe = Object.prototype, Ee = Pe.hasOwnProperty;
function Me(r) {
  if (!q(r))
    return Re(r);
  var e = [];
  for (var n in Object(r))
    Ee.call(r, n) && n != "constructor" && e.push(n);
  return e;
}
t(Me, "baseKeys");
var m = x(c, "Map");
function rr(r) {
  return r == null ? "" : G(r);
}
t(rr, "toString");
function Ie(r, e, n, u) {
  for (var a = -1, S = r == null ? 0 : r.length; ++a < S; )
    n = e(n, r[a], a, r);
  return n;
}
t(Ie, "arrayReduce");
function Ue(r) {
  return function(e) {
    return r == null ? void 0 : r[e];
  };
}
t(Ue, "basePropertyOf");
var ke = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, Le = Ue(ke), De = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Ne = "\\u0300-\\u036f", Fe = "\\ufe20-\\ufe2f", ze = "\\u20d0-\\u20ff", We = Ne + Fe + ze, Be = "[" + We + "]", Ve = RegExp(Be, "g");
function Ze(r) {
  return r = rr(r), r && r.replace(De, Le).replace(Ve, "");
}
t(Ze, "deburr");
var _e = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function Ge(r) {
  return r.match(_e) || [];
}
t(Ge, "asciiWords");
var He = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function Je(r) {
  return He.test(r);
}
t(Je, "hasUnicodeWord");
var er = "\\ud800-\\udfff", Ke = "\\u0300-\\u036f", qe = "\\ufe20-\\ufe2f", Ye = "\\u20d0-\\u20ff", Xe = Ke + qe + Ye, tr = "\\u2700-\\u27bf", nr = "a-z\\xdf-\\xf6\\xf8-\\xff", Qe = "\\xac\\xb1\\xd7\\xf7", rt = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", et = "\\u2000-\\u206f", tt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", or = "A-Z\\xc0-\\xd6\\xd8-\\xde", nt = "\\ufe0e\\ufe0f", ur = Qe + rt + et + tt, ar = "['’]", U = "[" + ur + "]", ot = "[" + Xe + "]", cr = "\\d+", ut = "[" + tr + "]", ir = "[" + nr + "]", fr = "[^" + er + ur + cr + tr + nr + or + "]", at = "\\ud83c[\\udffb-\\udfff]", ct = "(?:" + ot + "|" + at + ")", it = "[^" + er + "]", sr = "(?:\\ud83c[\\udde6-\\uddff]){2}", dr = "[\\ud800-\\udbff][\\udc00-\\udfff]", s = "[" + or + "]", ft = "\\u200d", k = "(?:" + ir + "|" + fr + ")", st = "(?:" + s + "|" + fr + ")", L = "(?:" + ar + "(?:d|ll|m|re|s|t|ve))?", D = "(?:" + ar + "(?:D|LL|M|RE|S|T|VE))?", br = ct + "?", gr = "[" + nt + "]?", dt = "(?:" + ft + "(?:" + [it, sr, dr].join("|") + ")" + gr + br + ")*", bt = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", gt = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", pt = gr + br + dt, xt = "(?:" + [ut, sr, dr].join("|") + ")" + pt, yt = RegExp([
  s + "?" + ir + "+" + L + "(?=" + [U, s, "$"].join("|") + ")",
  st + "+" + D + "(?=" + [U, s + k, "$"].join("|") + ")",
  s + "?" + k + "+" + L,
  s + "+" + D,
  gt,
  bt,
  cr,
  xt
].join("|"), "g");
function lt(r) {
  return r.match(yt) || [];
}
t(lt, "unicodeWords");
function jt(r, e, n) {
  return r = rr(r), e = e, e === void 0 ? Je(r) ? lt(r) : Ge(r) : r.match(e) || [];
}
t(jt, "words");
var Tt = "['’]", mt = RegExp(Tt, "g");
function vt(r) {
  return function(e) {
    return Ie(jt(Ze(e).replace(mt, "")), r, "");
  };
}
t(vt, "createCompounder");
var v = x(c, "DataView"), A = x(c, "Promise"), O = x(c, "Set"), N = "[object Map]", At = "[object Object]", F = "[object Promise]", z = "[object Set]", W = "[object WeakMap]", B = "[object DataView]", Ot = f(v), St = f(m), ht = f(A), $t = f(O), wt = f(T), i = b;
(v && i(new v(new ArrayBuffer(1))) != B || m && i(new m()) != N || A && i(A.resolve()) != F || O && i(new O()) != z || T && i(new T()) != W) && (i = /* @__PURE__ */ t(function(r) {
  var e = b(r), n = e == At ? r.constructor : void 0, u = n ? f(n) : "";
  if (u)
    switch (u) {
      case Ot:
        return B;
      case St:
        return N;
      case ht:
        return F;
      case $t:
        return z;
      case wt:
        return W;
    }
  return e;
}, "getTag"));
var Ct = "[object Map]", Rt = "[object Set]", Pt = Object.prototype, Et = Pt.hasOwnProperty;
function It(r) {
  if (r == null)
    return !0;
  if (Zr(r) && (_(r) || typeof r == "string" || typeof r.splice == "function" || Qr(r) || we(r) || Kr(r)))
    return !r.length;
  var e = i(r);
  if (e == Ct || e == Rt)
    return !r.size;
  if (q(r))
    return !Me(r).length;
  for (var n in r)
    if (Et.call(r, n))
      return !1;
  return !0;
}
t(It, "isEmpty");
var Ut = vt(function(r, e, n) {
  return r + (n ? "-" : "") + e.toLowerCase();
});
export {
  It as i,
  Ut as k
};
//# sourceMappingURL=awt-0-lodash-nxYJI_oT.js.map
